import { render } from "./SurveyVerification.vue?vue&type=template&id=3ac496c8&scoped=true"
import script from "./SurveyVerification.vue?vue&type=script&lang=js"
export * from "./SurveyVerification.vue?vue&type=script&lang=js"

import "./SurveyVerification.vue?vue&type=style&index=0&id=3ac496c8&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ac496c8"]])

export default __exports__